import type { LeaderboardTopContentPropTypes } from './LeaderboardSidebar.props';
import type { ReactElement } from 'react';

import { Flex, Heading, Text } from '@rango-dev/whale';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useWindowDimensions } from '../../../hooks/useWindowDimensions';
import { LeaderboardMenu } from '../LeaderboardMenu/LeaderboardMenu';

export function LeaderboardTopContent(props: LeaderboardTopContentPropTypes): ReactElement {
  const { activeTab } = props;
  const { t } = useTranslation();
  const { isTablet, isMobile } = useWindowDimensions();

  const isSmall = isTablet || isMobile;

  return (
    <Flex direction="column" gap="6" width="100%">
      <Flex direction="column" gap={{ initial: '1', md: '0' }} align="start">
        <Heading size="5" weight="bold">
          {t('Leaderboard')}
        </Heading>
        <Flex align="center" gap="2">
          <Text size="2" color="gray">
            {t('Track your score and campaigns')}
          </Text>
        </Flex>
      </Flex>
      {!isSmall && <LeaderboardMenu activeTab={activeTab} />}
    </Flex>
  );
}
